import React from 'react';
import styles from './accordion.module.css';
import Link from "gatsby-link"

/*
  category = {
    headerLink: ..
    title: ...
    courses: [
     {link: .. , title: ..},
     {link: .. , title: ..}
    ]
  }
*/
const iconHeader = (type, title) => {
  if (type === "medicine") {
    return <div className={styles.header + " " + styles.heartIcon}>
             <div className={styles.headerText}>{title}</div>
           </div>
  } else if (type === "engineering") {
    return <div className={styles.header + " " + styles.engineeringIcon}>
             <div className={styles.headerText}>{title}</div>
           </div>
  } else if (type === "creative") {
    return <div className={styles.header + " " + styles.creativeIcon}>
             <div className={styles.headerText}>{title}</div>
           </div>
  } else if (type === "social") {
    return <div className={styles.header + " " + styles.socialIcon}>
             <div className={styles.headerText}>{title}</div>
           </div>
  } else if (type === "business") {
    return <div className={styles.header + " " + styles.businessIcon}>
             <div className={styles.headerText}>{title}</div>
           </div>
  } else if (type === "science") {
    return <div className={styles.header + " " + styles.scienceIcon}>
             <div className={styles.headerText}>{title}</div>
           </div>
  }
};

const AccordionMenu = ({category}) => {
    return (
    <div className={styles.section}>
      <div className={styles.body}>
        <a href={category.headerLink} className={styles.headerLink} />
        {iconHeader(category.type, category.title)}

        <div className={styles.lower}>
          {category.courses.map(c => (<a href={c.link} className={styles.row}>{c.title}</a>))}
        </div>
      </div>
    </div>
    );
}

export default AccordionMenu;



// WEBPACK FOOTER //
// ./src/components/AccordionMenu/index.js